export default __webpack_public_path__ + "static/media/search.8b978826.svg";